export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#C9A84C]/15">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-[2px] h-10 bg-[#C9A84C]"></div>
              <div>
                <div className="font-serif text-white text-[17px] font-bold tracking-[0.1em] uppercase">
                  Gamble <span className="text-[#C9A84C]">&amp;</span> Garcia
                </div>
                <div className="text-[#C9A84C]/55 text-[9px] tracking-[0.38em] uppercase font-light">Attorneys at Law</div>
              </div>
            </div>
            <p className="text-white/30 text-sm leading-relaxed mb-7">
              Experienced legal representation for individuals and businesses throughout California&apos;s Central Coast.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.lawyers.com/santa-maria/california/gamble-garcia-attorneys-at-law-300040859-f/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/8 hover:border-[#C9A84C] hover:text-[#C9A84C] text-white/30 transition-all duration-300 cursor-pointer"
                title="Lawyers.com"
              >
                <i className="ri-scales-3-line text-sm"></i>
              </a>
              <a
                href="https://www.martindale.com/organization/gamble-garcia-attorneys-at-law-300029651/santa-maria-california-300040859-f/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/8 hover:border-[#C9A84C] hover:text-[#C9A84C] text-white/30 transition-all duration-300 cursor-pointer"
                title="Martindale"
              >
                <i className="ri-award-line text-sm"></i>
              </a>
              <a
                href="https://www.avvo.com/attorneys/93454-ca-william-gamble-171504.html"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/8 hover:border-[#C9A84C] hover:text-[#C9A84C] text-white/30 transition-all duration-300 cursor-pointer"
                title="Avvo"
              >
                <i className="ri-user-star-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Practice Areas */}
          <div>
            <h4 className="text-[#C9A84C] text-[10px] tracking-[0.38em] uppercase font-semibold mb-6">Practice Areas</h4>
            <ul className="space-y-2.5">
              {[
                'Criminal Defense',
                'Personal Injury',
                'Family Law',
                'Civil Litigation',
                'Drug Crimes',
                'Federal Defense',
                'Auto Accidents',
                'Wrongful Death',
                'Expungements',
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#practice-areas"
                    onClick={(e) => { e.preventDefault(); scrollTo('#practice-areas'); }}
                    className="text-white/35 text-sm hover:text-[#C9A84C] transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#C9A84C] text-[10px] tracking-[0.38em] uppercase font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', id: '#home' },
                { label: 'Practice Areas', id: '#practice-areas' },
                { label: 'Our Process', id: '#process' },
                { label: 'Service Areas', id: '#service-areas' },
                { label: 'Client Reviews', id: '#testimonials' },
                { label: 'FAQ', id: '#faq' },
                { label: 'Free Consultation', id: '#contact' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.id}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                    className="text-white/35 text-sm hover:text-[#C9A84C] transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#C9A84C] text-[10px] tracking-[0.38em] uppercase font-semibold mb-6">Contact</h4>
            <div className="space-y-6">
              <div>
                <div className="text-white/22 text-[10px] tracking-[0.3em] uppercase mb-2">Santa Maria</div>
                <p className="text-white/50 text-sm leading-relaxed">
                  301 E. Cook Street, Suite E<br />
                  Santa Maria, CA 93454-5133
                </p>
                <a href="tel:8059228308" className="text-[#C9A84C] text-sm mt-2 block hover:underline cursor-pointer">
                  (805) 922-8308
                </a>
              </div>
              <div>
                <div className="text-white/22 text-[10px] tracking-[0.3em] uppercase mb-2">San Luis Obispo</div>
                <p className="text-white/50 text-sm leading-relaxed">
                  2146 Parker Street, Suite A-3<br />
                  San Luis Obispo, CA 93401
                </p>
                <a href="tel:8059228308" className="text-[#C9A84C] text-sm mt-2 block hover:underline cursor-pointer">
                  (805) 922-8308
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5 py-6">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-4">
            <p className="text-white/20 text-xs text-center sm:text-left">
              &copy; {new Date().getFullYear()} Gamble &amp; Garcia Attorneys at Law. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-5 justify-center">
              {['Privacy Policy', 'Disclaimer', 'Site Map'].map((item) => (
                <a
                  key={item}
                  href="#"
                  rel="nofollow"
                  className="text-white/20 text-xs hover:text-[#C9A84C] transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
          <p className="text-white/12 text-[11px] leading-relaxed">
            Attorney Advertising. This website is designed for general informational purposes only. Information on this website does not constitute legal advice, nor does it form an attorney-client relationship. Gamble &amp; Garcia, Attorneys at Law serves clients in and around Santa Maria, Casmalia, Los Alamos, Guadalupe, Nipomo, Lompoc, Buellton, Solvang, Los Olivos, Santa Ynez, Oceano, San Luis Obispo, and surrounding Central Coast communities.
          </p>
        </div>
      </div>
    </footer>
  );
}
